import React from 'react';
import { AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function Navbar({ courseTitle, toggleDrawer }) {
    return (
        <AppBar
            position="static"
            sx={{
                backgroundColor: '#fff',
                color: '#333',
                boxShadow: 'none',
                borderBottom: '1px solid #ddd',
                height: { xs: '56px', sm: '64px' }, // Adjust height dynamically
            }}
        >
            <Toolbar
                sx={{
                    minHeight: { xs: '56px', sm: '64px' }, // Match AppBar height
                    px: { xs: 2, sm: 3 }, // Add horizontal padding for icons
                }}
            >
                {/* Back Icon */}
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={() => window.history.back()}
                    sx={{
                        mr: 2, // Margin to separate from content
                        padding: { xs: 1, sm: 1.5 }, // Padding for better touch target on mobile
                    }}
                    aria-label="Go back"
                >
                    <ArrowBackIcon fontSize="medium" />
                </IconButton>

                {/* Title */}
                <Typography
                    variant="h6"
                    noWrap
                    sx={{
                        flexGrow: 1,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {courseTitle}
                </Typography>

                {/* Menu Icon */}
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={toggleDrawer}
                    sx={{
                        display: { xs: 'block', md: 'none' }, // Only show in mobile
                        padding: { xs: 1, sm: 1.5 }, // Padding for touch target
                    }}
                    aria-label="Open menu"
                >
                    <MenuIcon fontSize="medium" />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
}

export default Navbar;
